import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GeneralCatalogSelectService } from '../general-catalog-select.service';

export interface TypeDocumentsSelectOption {
  value: string;
  label: string;
  code?: string;
}

/** Catálogo `document_types` vía select unificado. */
@Injectable({ providedIn: 'root' })
export class TypeDocumentsSelectService {
  private readonly generalCatalogSelect = inject(GeneralCatalogSelectService);

  getOptions(): Observable<TypeDocumentsSelectOption[]> {
    return this.generalCatalogSelect
      .getListOptionsByPrefix('document_types')
      .pipe(
        map((options) =>
          options.map((o) => ({
            value: o.value,
            label: o.label,
            code: o.code || '',
          })),
        ),
      );
  }
}
